import { serviceSpgc } from './spgc/menu-services';

export const services = [
  {
    name: 'Transportes',
    url: '/transportes',
    external: false,
    list: [
      {
        name: 'Login Transportes',
        url: '/servicos',
        icon: 'account_circle',
        external: false,
      },
      // {
      //   name: "Carteira Macro Região",
      //   url: "/carteira-macro-regiao",
      //   icon: "fa-money-check",
      //   external: false,
      // },
      // {
      //   name: "Consulta de Pendências",
      //   url: "/consulta-de-pendencias",
      //   icon: "find_in_page",
      //   external: false
      // },
      // {
      //   name: "Certificado de Inclusão de Veículo",
      //   url: "/certificado-inclusao-de-veiculo",
      //   icon: "picture_in_picture",
      //   external: false
      // },
      // {
      //   name: "Certificado de Registro",
      //   url: "/certificado-de-registro",
      //   icon: "picture_in_picture_alt",
      //   external: false
      // },
      {
        name: 'Consulta Transportadoras Regularizadas',
        url: '/consulta-transportadoras-regularizadas',
        icon: 'business',
        external: false,
      },
      {
        name: 'Cadastro Transportadora',
        url: '/cadastro-transportadora',
        icon: 'assignment',
        external: false,
      },
      {
        name: 'Linhas Regulares de Passageiros',
        url: '/linhas-regulares',
        icon: 'directions_bus',
        external: false,
      },
      {
        name: 'Passe Livre Intermunicipal',
        url: '/passe-livre',
        icon: 'fa-address-card',
        external: false,
      },
      {
        name: 'Rota das Emoções',
        url: '/rota-emocoes',
        icon: 'near_me',
        external: false,
      },
      {
        name: 'Validação de Certificado',
        url: '/validacao-de-certificado',
        icon: 'select_all',
        external: false,
      },
      // {
      //   name: "Extrato de Infração",
      //   url: "/extrato-de-infracao",
      //   icon: "receipt",
      //   external: false
      // },
      // {
      //   name: "Renovação Cadastro Transportadora",
      //   url: "/pedidos/renovacao-transportadora",
      //   icon: "assignment",
      //   external: false
      // },
      // {
      //   name: "Inclusão de Veículo",
      //   url: "/pedidos/inclusao-veiculo",
      //   icon: "assignment",
      //   external: false
      // },
      // {
      //   name: "Exclusão de Veículo",
      //   url: "/pedidos/exclusao-veiculo",
      //   icon: "assignment",
      //   external: false
      // },
      // {
      //   name: "Licença Especial",
      //   url: "/licenca-especial",
      //   icon: "beenhere",
      //   external: false
      // },
      // {
      //   name: "Notificação de Infração",
      //   url: "/notificacao-de-infracao",
      //   icon: "notification_important",
      //   external: false
      // },
      // {
      //   name: "Renovação do Registro de Veículo",
      //   url: "/pedidos/renovacao-registro-veiculo",
      //   icon: "assignment",
      //   external: false
      // },
      // {
      //   name: "Relatório de Frota Veículo",
      //   url: "/relatorio-frota-veiculo",
      //   icon: "insert_chart",
      //   external: false
      // },
      // {
      //   name: "Relatório de Frota Auto de Infração",
      //   url: "/relatorio-frota-auto-infracao",
      //   icon: "pie_chart",
      //   external: false
      // },
      // {
      //   name: "Taxas Avulsas",
      //   url: "/taxas-avulsas",
      //   icon: "fa-barcode",
      //   external: false
      // },
    ],
  },
  {
    name: "VaiVem",
    url: "/vaivem",
    icon: "fa-id-card",
    external: false,
    list: [
      {
        name: "Consulta CPF",
        url: "/consulta-cpf",
        icon: "fa-id-card",
        external: false,
      },
      {
        name: "Entrega da Carteira",
        url: "/confirmar-entrega",
        icon: "fa-bus",
        external: false,
      },
    ],
  },
  {
    name: "Ouvidoria",
    url: "/ouvidoria",
    external: false,
    list: [
      {
        name: 'Fale com Presidente',
        url: '/fale-com-presidente',
        icon: 'contact_phone',
        external: false,
      },
      // {
      //   name: "Solicitação",
      //   url: "/solicitacao",
      //   icon: "touch_app",
      //   external: false
      // },
      // {
      //   name: "Acompanhar Solicitação",
      //   url: "/acompanhar-solicitacao",
      //   icon: "call_split",
      //   external: false
      // },
      {
        name: 'Legislação',
        url: 'https://www.arce.ce.gov.br/institucional/legislacao/',
        icon: 'book',
        external: true,
      },
      // {
      //   name: "Painel da Ouvidoria",
      //   url: "/painel-da-ouvidoria",
      //   icon: "query_stats",
      //   external: false
      // },
    ],
  },
  {
    name: 'Processos',
    url: '/processos',
    external: false,
    list: [
      {
        name: 'Consultar Processos até 2020',
        url: '/consultar-processos-ate-2020',
        icon: 'fa-book',
        external: false,
      },
      {
        name: 'Consultar Processos entre 2021 e 2023',
        url: '/consultar-processos-entre-2021-e-2023',
        icon: 'fa-book',
        external: false,
      },
      {
        name: 'Consultar Processos a partir de 2024',
        url: '/consultar-processos-a-partir-de-2024',
        icon: 'fa-book',
        external: false,
      },
      {
        name: 'Notificação de Penalidade ate 2023',
        url: '/notificacao-de-penalidade-ate-2023',
        icon: 'sms_failed',
        external: false,
      },
      {
        name: 'Notificação de Penalidade a partir de 2024',
        url: '/notificacao-de-penalidade-a-partir-de-2024',
        icon: 'sms_failed',
        external: false,
      },
      {
        name: 'Relatório de Julgamento até 2023',
        url: '/relatorio-de-julgamento-ate-2023',
        icon: 'gavel',
        external: false,
      },
      {
        name: 'Relatório de Julgamento a partir de 2024',
        url: '/relatorio-de-julgamento-a-partir-2024',
        icon: 'gavel',
        external: false,
      },
      {
        name: 'NJI DAEs',
        url: '/nji-dae',
        icon: 'article',
        external: false,
      },
    ],
  },
  {
    name: 'Carteira Macrorregião',
    url: '/carteira-macrorregiao',
    external: false,
    list: [
      {
        name: 'Aluno',
        url: '/aluno',
        icon: 'account_box',
        external: false,
      },
      {
        name: 'Entidade',
        url: '/login-entidade',
        icon: 'web',
        external: false,
      },
      {
        name: 'Gráfica',
        url: '/login-grafica',
        icon: 'contacts',
        external: false,
      },
    ],
  },
  // {
  //   name: 'Financeiro',
  //   url: '/financeiro',
  //   external: false,
  //   list: [
  //     // {
  //     //   name: "Validar Certidão Negativa",
  //     //   url: "/certidao-negativa/validar",
  //     //   icon: "fact_check",
  //     //   external: false
  //     // },
  //     {
  //       name: 'Gerar Certidão Negativa',
  //       url: '/certidao-negativa/gerar',
  //       icon: 'newspaper',
  //       external: false,
  //     },
  //   ],
  // },
  {
    name: "Confirmar Entrega",
    url: "/vaivem/confirmar-entrega",
    external: false,
    list: [
      {
        name: "Estudante",
        url: "/estudante/login",
        icon: "assignment_ind",
        external: false,
      },
      {
        name: "Trabalhador",
        url: "/trabalhador/login",
        icon: "work",
        external: false,
      },
    ]
  },
  {
    name: "Saneamento",
    url: "/saneamento",
    external: false,
    list: [
      {
        name: 'Login Saneamento',
        url: '/login',
        icon: 'water_drop',
      },
    ],
  },
  ...serviceSpgc,
    {
    name: "Cadastro Positivo de Veículos",
    url: "/cpv",
    external: false,
    list: [
      {
        name: "Login CPV",
        url: "",
        icon: "directions_car",
        external: false,
      },
    ],
  },
];
